module.exports = __webpack_public_path__ + "static/media/reactjs.fe5789ed.png";